import { render, staticRenderFns } from "./iframe-website-settings.vue?vue&type=template&id=f5ebf52e&scoped=true"
import script from "./iframe-website-settings.vue?vue&type=script&lang=js"
export * from "./iframe-website-settings.vue?vue&type=script&lang=js"
import style0 from "./iframe-website-settings.vue?vue&type=style&index=0&id=f5ebf52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ebf52e",
  null
  
)

export default component.exports